import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import './setup-amplify';
import ReactGA from 'react-ga4';

import axios from "axios";
import { createGlobalStyle } from 'styled-components';

axios.defaults.timeout = 10000;

ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID!);
ReactGA.send('pageview');

const FontStyles = createGlobalStyle`
    @font-face {
        font-family: 'Kiwi Maru';
        src: url(/fonts/KiwiMaru-Regular.ttf);
    }
`

ReactDOM.render(
    <React.StrictMode>
        <FontStyles />
    <App />
    </React.StrictMode>,
    document.getElementById('root')
)